import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import { salaryFormatter } from "utils/formatters";
import PropTypes from "prop-types";
import { renderInitialLoaderOrNoResult } from "utils/toolsManagerHelper";

const AbaqueToolsByFilters = ({
  statsHistorySalaryByBranches,
  statsHistorySalaryByBranchesStatus,
}) => {
  const header = [
    {
      label: {
        key: "years-exp",
        value: (
          <FormattedMessage
            id="years_experience_header"
            defaultMessage={"Années d'expérience"}
          />
        ),
      },
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "years_experience_header",
    },

    {
      label: {
        key: "number-persons",
        value: (
          <FormattedMessage
            id="number_persons"
            defaultMessage={"Nombre de personnes"}
          />
        ),
      },
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "number_persons",
    },
    {
      label: {
        key: "max-salary",
        value: (
          <FormattedMessage id="max_salary" defaultMessage={"Salaire max."} />
        ),
      },
      icon: "salary",
      iconWidth: 20,
      iconHeight: 20,
      id: "max_salary",
    },
    {
      label: {
        key: "min-salary",
        value: (
          <FormattedMessage id="min_salary" defaultMessage={"Salaire min."} />
        ),
      },
      icon: "salary",
      iconWidth: 20,
      iconHeight: 20,
      id: "min_salary",
    },
    {
      label: {
        key: "average-salary",
        value: (
          <FormattedMessage
            id="average_salary"
            defaultMessage={"Salaire moyen"}
          />
        ),
      },
      icon: "salary",
      iconWidth: 20,
      iconHeight: 20,
      id: "average_salary",
    },
    {
      label: {
        key: "median-salary",
        value: (
          <FormattedMessage
            id="median_salary"
            defaultMessage={"Salaire médian"}
          />
        ),
      },
      icon: "salary",
      iconWidth: 20,
      iconHeight: 20,
      id: "median_salary",
    },
  ];

  const dashDisplay = (number) => (number === 0 ? "-" : number);

  const getFormattedAbaque = (stats) => {
    const filteredStats = stats?.filter((elem) => elem.experience >= 0);
    return filteredStats?.map((elem) => ({
      experience: `${elem.experience} année${elem.experience <= 1 ? "" : "s"}`,
      nb_person: dashDisplay(elem.nb_person),
      salary_max: dashDisplay(salaryFormatter(elem.salary_max)),
      salary_min: dashDisplay(salaryFormatter(elem.salary_min)),
      salary_avg: dashDisplay(salaryFormatter(elem.salary_avg)),
      salary_median: dashDisplay(salaryFormatter(elem.salary_median)),
    }));
  };

  return (
    <div className="section">
      {renderInitialLoaderOrNoResult({
        status: statsHistorySalaryByBranchesStatus,
        hasContent: statsHistorySalaryByBranches?.length,
      })}
      {statsHistorySalaryByBranches?.length > 0 && (
        <>
          <div className="display-flex">
            <Typography
              className="title-3 violet text-uppercase"
              type="h2"
              label={
                <FormattedMessage id="results" defaultMessage="Résultats" />
              }
            />
          </div>
          <div>
            <Table
              id={`abaque-by-filters`}
              header={header}
              content={getFormattedAbaque(statsHistorySalaryByBranches) || []}
              tableWidth={"100%"}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AbaqueToolsByFilters;

AbaqueToolsByFilters.propTypes = {
  statsHistorySalaryByBranches: PropTypes.array,
  statsHistorySalaryByBranchesStatus: PropTypes.string,
};
